// @flow

import { useTranslator, type TranslatorProps } from '@gandi/translate';

import { SetupPill } from '../SetupPill';

import { useDomainContacts, type OwnProps as Props } from './hooks';

function getTranslation(__: TranslatorProps['__'], contactType: string) {
  switch (contactType) {
    case 'custom':
      return __('Custom contacts used.');
    default:
      return __('Default contacts used.');
  }
}

export function DomainContactsCellContents(props: Props): React.MixedElement {
  const { __ } = useTranslator();
  const { committed, contactType, contactsChangeURL } =
    useDomainContacts(props);

  return (
    <SetupPill to={contactsChangeURL} disabled={committed}>
      {getTranslation(__, contactType)}
    </SetupPill>
  );
}
